
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("czXBj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fb664d64f1bf5ecb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $fb664d64f1bf5ecb$export$2e2bcd8739ae039 = {
    'confluence-analytics-chart.default-loading-text': "\uBD84\uC11D \uB370\uC774\uD130 \uC0C8\uB85C \uACE0\uCE58\uB294 \uC911...",
    'confluence-analytics-chart.tooltip.no-views-data': "\uB370\uC774\uD130 \uC5C6\uC74C",
    'confluence-analytics-chart.tooltip.views-overall': "{count, plural, other {\uC870\uD68C\uC218 {count}\uD68C}}",
    'confluence-analytics-chart.tooltip.views-today-so-far': "{count, plural, other {\uC9C0\uAE08\uAE4C\uC9C0\uC758 \uC870\uD68C\uC218 {count}\uD68C}}",
    'confuence-analytics-chart.accessible-table.caption': "\uD398\uC774\uC9C0 \uC870\uD68C\uC218",
    'confuence-analytics-chart.accessible-table.header.date': "\uB0A0\uC9DC",
    'confuence-analytics-chart.accessible-table.header.view-count': "\uC870\uD68C\uC218",
    'confuence-analytics-chart.accessible-table.no-view-count-data': "\uC870\uD68C\uC218 \uC5C6\uC74C"
};

});


//# sourceMappingURL=ko.64187264.js.map
